'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsUnassignedResponderInWidget = undefined;

var _reselect = require('reselect');

var _getAssignedResponderInWidget = require('./getAssignedResponderInWidget');

var _responderGetters = require('conversations-schema/responders/operators/responderGetters');

var getIsUnassignedResponderInWidget = exports.getIsUnassignedResponderInWidget = (0, _reselect.createSelector)([_getAssignedResponderInWidget.getAssignedResponderInWidget], function (assignedResponder) {
  return !assignedResponder || (0, _responderGetters.getIsBot)(assignedResponder);
});